module.exports = __webpack_public_path__ + "static/media/archibeau_gisenyi3.401aba45.jpg";